export const PlayerEventType = {
    StartSession: 'startSession',
    EndSession: 'endSession',
    UpdateSessionData: 'updateSessionData',
    UpdateSessionState: 'updateSessionState',
    InstantEvent: 'instantEvent'
};

export const PlayerEventStateType = {
    ContentPage: 'page',
    PlayBack: 'playback',
    Zoom: 'zoom',
    Search: 'search',
    Screen: 'screen',
    Viewport: 'viewport',
    Volume: 'volume'
};

export const PlayBackState = {
    Loading: 'loading',
    Loaded: 'loaded',
    Playing: 'playing',
    Paused: 'paused',
    Ended: 'ended'
};

export const PlayerEventSessionType = {
    Image: 'Image',
    Video: 'Video',
    URL: 'URL',
    Firestorm: 'Firestorm',
    Audio: 'Audio',
    Failed: 'Failed'
};

export const InstantEventType = {
    download: 'fileDownload',
    tiledEvent: 'tiledEvent'
};

export const TiledEventActionName = {
    visited: 'screen visited',
    exited: 'screen exited',
    sessionStart: 'session start',
    sessionEnd: 'session end',
    videoStarted: 'video started',
    videoStoped: 'video stopped',
    inactive: 'inactive',
    resumed: 'activity resumed'
};
